import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';

import LocalStorageService from '../services/utilities/LocalStorageService';
import { Modal } from '../components/Modal';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import { Confirmation } from '../components/modals/common/';
import { formatTel } from '../utilities/stringUtil';
import { changeImageDataToBlob } from '../utilities/imageUtility';
import masterSlideLoader from '../utilities/masterSlideLoader';
import {
  isTargetRoleId,
  isPrimaryCompanyRoleId,
  isPartnerCompanyRoleId,
  isForemanRoleId,
} from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';
import EventManager, { EventType } from '../utilities/EventManager';
import AuthProvider from '../utilities/authProvider';
import {
  INTEGRATE_USER_CHANGE_EMAIL_CONFIRM_MESSAGE,
  HEADER_CONSTANTS,
  maxiileSize,
  USER_ROLES,
  USER_VIEW_MODE,
} from '../utilities/constants';
import { MasterPageHeader } from '../components/PageHeader';
import { UserForm } from '../components/UserForm';
import UserApi from '../services/user/UserApi';
import UsersApi from '../services/users/UsersApi';
import UserService from '../services/user/UserService';
import { UserService as UserServiceApi } from '../services/Users';
import Information from '../components/modals/common/Information';
import { HEAD_OFFICE_OPTION } from '../components/PartnerCompanyBranchDropdown';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { LoginUserGroupsService } from '../services/LoginUserGroups';
import { ConfirmChangeIntegratedEmailDialog } from '../components/modals/ConfirmChangeIntegratedEmailDialog';

/**
 * 利用者編集画面
 */
export class UserEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validate: {},
      validationMessage: {},
      tempCompanyBranch: {}, // ユーザー種別変更用選択支店
      params: {
        login_id: '',
        user_role_code: null, // ユーザー種別
        buildee_manager_flg: false, // Buildeeマネジャーフラグ
        use_chosei_flg: false, // 調整会議利用権限有無
        use_green_file_flg: false, // 調整会議利用権限有無
        use_nyutaijo_flg: false, // 入退場利用権限有無
        name_sei: '', // 姓
        name_mei: '', // 名
        kana_sei: '', // せい
        kana_mei: '', // めい
        tel: '', // 電話番号
        fax: '', // Fax
        email: '', // ユーザーID(メールアドレス)
        company_branch: null, // 支店
        partner_company_branch: {
          id: null,
          name: '',
        },
        image_url: '', // 画像ファイルアイコン
      }, // フォームの値を保持
      dialog_show: false, // ダイアログフラグ
      userId: '',
      viewerId: LocalStorageService.getUserId(), //操作中のユーザーID
      loginId: LocalStorageService.getItem('login_id'), //操作中のログインID
      isPrimary: isPrimaryCompanyRoleId(LocalStorageService.getRoleId()),
      inputCount: 0, // 必須項目入力数
      requiredNumber: 0, // 全必須項目数
      errorDialogFlg: false, //エラーダイアログ表示フラグ
      errorMessage: '', //エラーメッセージ
      isManagerPermission: false,
      hasManagerPermission: true,
      selectedTabId: '',
      events: {
        onChange: this.onChange,
        onBlur: this.onBlur,
        back: this.back,
        submit: this.submit,
      },
      visibleChangeIntegratedEmail: false,
      groupIntegratedUsers: [],
      confirmChangeIntegratedEmail: null,
    };

    // slideLoaderからの情報を取得
    if (props.view) {
      this.state.userId = props.view.state.id;
    }

    // 必須項目ステータス
    this.requiredList = {
      login_id: false,
      user_role_code: true, // ユーザー種別
      name_sei: false, // 性
      name_mei: false, // 名
      kana_sei: false, // せい
      kana_mei: false, // めい
      email: false, // ユーザーID(メールアドレス)
      company_branch_id: false, // 支店
      partner_company_branch_id: false, // 支店
    };

    // roleId を保持しておく
    this.roleId = LocalStorageService.getRoleId();
    this.companyId = SessionStorageService.getCompanyId(); // 本社ID
    this.userId = LocalStorageService.getUserId(); // ユーザーID

    this.defaultCompanyBranch = null;
    this.partnerCompanyJoiningFlag = SessionStorageService.getPartnerCompanyJoiningFlag();
    this.hasPartnerCompanyBranchDropdown = false;
    this.oldEmail = null;
    this.isSubmittingFlag = false;
  }

  async componentDidMount() {
    await this.settingPermission();
    this.setPartnerCompanyBranchInitValue();
    this.onLoad();
  }

  setPartnerCompanyBranchInitValue = () => {
    if (
      this.partnerCompanyJoiningFlag &&
      isPartnerCompanyRoleId(this.roleId) &&
      this.state.isManagerPermission
    ) {
      this.hasPartnerCompanyBranchDropdown = true;
      this.requiredList.partner_company_branch_id = true;
    } else {
      delete this.requiredList.partner_company_branch_id;
    }
  };

  getHeaderTitle = () => {
    return this.state.isPrimary
      ? '利用者詳細・編集'
      : '利用者詳細・編集 （協力会社）';
  };

  /**
   * 利用者詳細に戻る
   * */
  back = () => {
    this.setState({ dialog_show: true });
  };

  /**
   * @description ダイアログ開閉設定
   * @param {boolean} isShow ダイアログ on/off
   */
  handleVisibleDialog = isShow => {
    this.setState({ visibleConfirmation: isShow });
  };

  /**
   * @description ユーザー情報を取得
   */
  onLoad = async () => {
    UserApi.fetch(this.state.userId)
      .then(response => {
        if (response.result) {
          let params = response.data.entities.user;
          params.user_role_code = params.user_role.code;
          if (!_.isEmpty(params.company_branch)) {
            params.company_branch = params.company_branch[0];
            params.company_branch_id = params.company_branch.id;
            this.defaultCompanyBranch = _.cloneDeep(params.company_branch);
          }
          if (this.hasPartnerCompanyBranchDropdown) {
            const partnerCompanyBranchId = _.get(
              params,
              'partner_company_branch.id'
            );
            params.partner_company_branch_id =
              partnerCompanyBranchId || HEAD_OFFICE_OPTION.id;
            if (!partnerCompanyBranchId) {
              params.partner_company_branch = {
                id: HEAD_OFFICE_OPTION.id,
                name: HEAD_OFFICE_OPTION.name,
              };
            }
          }
          this.oldEmail = params.email;
          this.setState({ params }, () => {
            this.onChange('user_role_code', params.user_role_code);
          });
        }
      })
      .catch(e => {
        // NOTE
        // 本来であればエラーダイアログで表示すべきだが、
        // 共通化まえは握りつぶしていたのでひとまず、アラート表示のみ実装
        alert(`エラーです：${e}`);
      });
  };

  /**
   * @description 「サービス権限の一括変更」ボタンの表示
   */
  settingPermission = () => {
    return UsersApi.fetchCompanyUserPermissions(this.companyId, {
      buildee_manager_flg: 1,
    })
      .then(res => {
        let isManagerPermission = false;
        let hasManagerPermission = true;
        if (res.result === true) {
          if (res.data.total === 0) {
            hasManagerPermission = false;
          } else {
            const companyUserPermissions =
              res.data.entities.company_user_permissions;
            for (let permission of companyUserPermissions) {
              if (permission.user_id === Number(this.userId)) {
                isManagerPermission = true;
                break;
              }
            }
          }

          this.setState({
            isManagerPermission,
            hasManagerPermission,
          });
        } else {
          let errorMessage = '';
          if (res.message) {
            errorMessage = res.message;
          } else {
            errorMessage = res.data.message;
          }
          this.setState({ errorDialogFlg: true, errorMessage });
        }
      })
      .catch(error => {
        let errorMessage = '';
        if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = error.data.message;
        }
        this.setState({ errorDialogFlg: true, errorMessage });
      });
  };

  /***
   * @description 詳細な相関バリデーションチェック
   * @param {object} params 全入力パラメータ
   * @returns バリデーションチェック後のエラーメッセージオブジェクト
   */
  checkValidate = params => {
    let result = UserService.validate(params, this.state.isPrimary);
    result.messages = result.messages || {};
    if (params.user_image) {
      if (params.user_image.length > maxiileSize) {
        result.status = false;
        result.messages.user_image = '5MB以下の画像にしてください。';
      }
    }

    // 支店_バリデーションチェック
    if (!_.isUndefined(params.user_role_code)) {
      if (
        (isTargetRoleId([USER_ROLES.branch], params.user_role_code) &&
          isTargetRoleId([USER_ROLES.prime], this.roleId)) ||
        (isTargetRoleId([USER_ROLES.manager], params.user_role_code) &&
          isTargetRoleId([USER_ROLES.prime], this.roleId)) ||
        (isTargetRoleId([USER_ROLES.manager], params.user_role_code) &&
          isTargetRoleId([USER_ROLES.branch], this.roleId))
      ) {
        if (!params.company_branch_id) {
          delete params.company_branch_id;
        }
        if (!_.has(params, 'company_branch_id')) {
          result.status = false;
          result.messages.company_branch_id = messageUtility.getMessage(
            'E-000-023',
            '支店'
          );
        }
      }
    }

    return result;
  };

  /**
   * 現在とRoleを変更してるのか判定 & ダイアログ
   *
   * @param {object} params
   * @returns
   */
  isChangeMyRole = params => {
    if (params.user_role_code !== this.roleId) {
      this.setState({
        showModal: true,
        updateSuccess: false,
        updateMsg: messageUtility.getMessage('E-001-007'),
        updateMsgDetail: null,
      });

      return true;
    }

    return false;
  };

  /**
   * 入力した値を送信する
   */
  submit = () => {
    const state_params = _.cloneDeep(this.state.params);
    const params = this.createParams(state_params);
    let result = this.checkValidate(params);

    if (result.status) {
      this.setState({ validate: {} });

      if (!_.has(params, 'tel')) {
        params.tel = '';
      }
      if (_.size(params.user_image) === 0) {
        params.user_image = '';
      }
      if (
        isTargetRoleId(
          [USER_ROLES.manager, USER_ROLES.foreman],
          params.user_role_code
        )
      ) {
        params.buildee_manager_flg = false;
      }
      if (params.partner_company_branch_id === HEAD_OFFICE_OPTION.id) {
        params.partner_company_branch_id = '';
      }

      const myUserId = this.state.viewerId;
      const isMe = Number(this.state.userId) === myUserId;

      // 自分自身の場合, 現在のRoleを変更したら弾く
      if (isMe && this.isChangeMyRole(params)) {
        return;
      }

      if (this.oldEmail !== params.email && state_params.integrated) {
        this.setState(
          {
            visibleChangeIntegratedEmail: true,
            confirmChangeIntegratedEmail: () => {
              this.onHideConfirmChangeIntegratedEmail();
              this.runSubmit(params);
            },
          },
          this.getGroupIntegratedUsers
        );
        return;
      }

      // 自分自身の場合, login_id変更してたらログアウトすることの警告
      if (isMe && params.login_id !== this.state.loginId) {
        // 警告メッセージダイアログを開く
        this.handleVisibleDialog(true);
        // 警告メッセージダイアログのコールバック
        this.setState({
          confirm: () => {
            // 閉じる
            this.handleVisibleDialog(false);
            // 後でログアウトのsubmit実行
            this.runSubmit(params);
          },
        });
        return null;
      } else {
        this.runSubmit(params);
      }
    } else {
      // エラーメッセージを表示
      this.setState({
        validate: result.messages,
        validationMessage: result.messages,
      });
    }
  };

  /**
   * submitの実行
   *
   * @param {object} params
   */
  runSubmit = params => {
    // 連打防止
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;

    if (params.user_image !== '') {
      if (params.user_image.match(/image\/(.+);/)) {
        params.user_image = changeImageDataToBlob(params.user_image);
      } else {
        delete params.user_image;
      }
    }
    if (isTargetRoleId([USER_ROLES.partner], this.roleId)) {
      params.company_branch_id = SessionStorageService.getCompanyBranchId();
    }
    UserServiceApi.update(this.state.userId, params)
      .then(res => {
        if (res.result === true) {
          // 変更あったらログアウトフラグ
          const myUserId = this.state.viewerId;
          let isLogout = false;
          const isMe =
            Number(this.state.userId) === myUserId ||
            _.some(
              this.state.groupIntegratedUsers,
              user => user.id === myUserId
            );

          // 更新対象が自分
          if (isMe) {
            // login_id変更してたらログアウト
            if (params.email !== this.state.loginId) {
              isLogout = true;
            } else {
              // 右上のプロフィール情報更新
              // エラーになるのでlogin_idを変更しない時だけ更新する
              EventManager.trigger(EventType.REFRESH_PROFILE, {});
            }
          }

          // 更新しましたダイアログ
          this.setState({
            isLogout,
            showModal: true,
            updateSuccess: true,
            updateMsg: 'ユーザー更新完了',
            updateMsgDetail: 'ユーザーの更新が完了しました。',
          });
        } else {
          let errorMessage = '';
          if (res.message) {
            errorMessage = res.message;
          } else if (res.data.message) {
            errorMessage = res.data.message;
          } else {
            // errorに入ってないときは安全にデフォルトのエラーメッセージ
            errorMessage = messageUtility.getMessage('E-000-001');
          }
          // モーダルの表示(通信エラー)
          this.setState({
            showModal: true,
            updateSuccess: false,
            updateMsg: messageUtility.getMessage('E-001-402'),
            updateMsgDetail: errorMessage,
          });
        }
      })
      .catch(error => {
        this.setState({ showModal: true });
        this.setState({ updateSuccess: false });
        this.setState({
          updateMsg: messageUtility.getMessage('E-001-402'),
          updateMsgDetail: error[0].responseJSON.message,
        });
      })
      .finally(() => {
        this.isSubmittingFlag = false;
      });
  };

  createParams = stateParams => {
    const params = {};
    params.kana_mei = stateParams.kana_mei;
    params.kana_sei = stateParams.kana_sei;
    params.name_sei = stateParams.name_sei;
    params.name_mei = stateParams.name_mei;
    params.user_image = stateParams.image_url;
    params.user_role_code = stateParams.user_role_code;
    params.integrated = stateParams.integrated;
    params.email = stateParams.email;
    params.tel = formatTel(stateParams.tel);

    // 職長はログインIDがメールではないため
    if (
      this.state.isPrimary === false &&
      isTargetRoleId([USER_ROLES.foreman], params.user_role_code)
    ) {
      params.login_id = stateParams.login_id;
    } else {
      params.login_id = params.email;
    }

    if (params.integrated && isForemanRoleId(params.user_role_code)) {
      params.login_id = params.email;
    }

    // ユーザー種別が協力会社管理者の場合
    if (isTargetRoleId([USER_ROLES.partner], params.user_role_code)) {
      params.fax = formatTel(stateParams.fax);
    }

    params.company_branch_id = '';
    if (!_.isEmpty(stateParams.company_branch)) {
      params.company_branch_id = stateParams.company_branch.id;
    }
    // ユーザー種別が本社管理者の場合
    if (isTargetRoleId([USER_ROLES.prime], params.user_role_code)) {
      params.company_id = this.companyId;
      delete params.company_branch_id;
    }

    if (this.state.isManagerPermission) {
      params.buildee_manager_flg = stateParams.buildee_manager_flg;
      params.use_chosei_flg = stateParams.use_chosei_flg;
      params.use_green_file_flg = stateParams.use_green_file_flg;
      params.use_nyutaijo_flg = stateParams.use_nyutaijo_flg;
    }

    if (this.hasPartnerCompanyBranchDropdown) {
      params.partner_company_branch_id = stateParams.partner_company_branch_id;
    }

    return params;
  };

  onChange = (key, value) => {
    const state_params = _.cloneDeep(this.state.params);
    if (key === 'company_branch') {
      state_params['company_branch_id'] = value.id;
    }

    if (key === 'user_role_code') {
      // ユーザー種別を変更し、ユーザー種別が支店管理者で操作中のユーザのロールも支店管理者の場合
      if (
        isTargetRoleId([USER_ROLES.branch], value) &&
        isTargetRoleId([USER_ROLES.branch], this.roleId)
      ) {
        // 自社ブランチを固定で設定する
        state_params.company_branch = _.cloneDeep(this.defaultCompanyBranch);
        state_params.company_branch_id = state_params.company_branch.id;
      }
    }

    // サービス権限の場合
    if (key === 'permissions') {
      state_params.use_chosei_flg = value.use_chosei_flg;
      state_params.use_green_file_flg = value.use_green_file_flg;
      state_params.use_nyutaijo_flg = value.use_nyutaijo_flg;
    } else {
      state_params[key] = value;
    }

    if (key === 'partner_company_branch') {
      state_params['partner_company_branch_id'] = value.id;
    }

    this.setState({ params: state_params }, () => {
      const params = this.createParams(_.cloneDeep(this.state.params));
      this.setInputInfo(key, params);
      if (key === 'company_branch') {
        this.onBlur('company_branch_id');
      }
    });
  };

  onBlur = key => {
    // バリデーションを実行
    const state_params = _.cloneDeep(this.state.params);
    const params = this.createParams(state_params);
    let validationMessage = _.cloneDeep(this.state.validationMessage);
    let result = this.checkValidate(params);

    if (result.status === false && !_.isEmpty(result.messages[key])) {
      // 入力項目に誤りがある場合、エラーメッセージをセット
      validationMessage[key] = result.messages[key];
    } else {
      // 正常に入力している場合、エラーメッセージを削除
      delete validationMessage[key];
    }
    this.setState({ validationMessage });
  };

  setInputInfo = (key, params) => {
    if (!key) {
      return;
    }

    // 全必須項目数計算
    if (key === 'user_role_code' && !_.isUndefined(params.user_role_code)) {
      if (this.state.isPrimary) {
        if (
          isTargetRoleId([USER_ROLES.prime], params.user_role_code) ||
          (isTargetRoleId([USER_ROLES.branch], params.user_role_code) &&
            isTargetRoleId([USER_ROLES.branch], this.roleId)) ||
          isTargetRoleId([USER_ROLES.manager], this.roleId)
        ) {
          delete this.requiredList.company_branch_id;
        } else {
          if (_.has(params, 'company_branch_id')) {
            this.requiredList.company_branch_id = true;
          } else {
            this.requiredList.company_branch_id = false;
          }
        }
      } else {
        delete this.requiredList.company_branch_id;
      }
    }

    if (
      !this.state.isPrimary &&
      isForemanRoleId(params.user_role_code) &&
      !params.integrated
    ) {
      if (_.has(params, 'login_id')) {
        this.requiredList.login_id = true;
      } else {
        this.requiredList.login_id = false;
      }
      delete this.requiredList.email;
    } else {
      if (_.has(params, 'email')) {
        this.requiredList.email = true;
      } else {
        this.requiredList.email = false;
      }
      delete this.requiredList.login_id;
    }

    if (this.hasPartnerCompanyBranchDropdown) {
      this.requiredList.partner_company_branch_id = _.has(
        params,
        'partner_company_branch_id'
      );
    }
    if (key === 'partner_company_branch') {
      key = 'partner_company_branch_id';
    }
    if (key === 'company_branch') {
      key = 'company_branch_id';
    }
    if (_.has(this.requiredList, key)) {
      // 必須項目フォームを操作した場合
      if (
        key === 'user_role_code' &&
        (!this.state.isPrimary ||
          isTargetRoleId([USER_ROLES.manager], this.roleId))
      ) {
        delete this.requiredList.user_role_code;
      } else {
        this.requiredList[key] = UserService.isNormalValue(
          params,
          key,
          this.state.isPrimary
        );
      }
      let inputCount = UserService.getFraction(params, this.requiredList);
      if (inputCount !== this.state.inputCount) {
        this.setState({ inputCount });
      }
    }
    this.setState({ requiredNumber: _.size(this.requiredList) });
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = selectedTabId => {
    this.setState({
      selectedTabId,
      leaveThisPage: true,
    });
  };

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    this.setState({
      leaveThisPage: false,
    });
  };

  getGroupIntegratedUsers = () => {
    LoginUserGroupsService.list({
      user_id: this.state.userId,
    }).then(({ result, data }) => {
      if (result && this.state.visibleChangeIntegratedEmail) {
        this.setState({
          groupIntegratedUsers: _.get(data, 'entities.users') || [],
        });
      }
    });
  };

  onHideConfirmChangeIntegratedEmail = () => {
    this.setState({
      visibleChangeIntegratedEmail: false,
      confirmChangeIntegratedEmail: null,
    });
  };

  render() {
    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {this.getHeaderTitle()}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={this.getHeaderTitle()}
            onClose={() => this.setState({ dialog_show: true })}
          />
          {_.get(this.state.params, 'id') && (
            <UserForm
              userId={this.state.userId}
              viewMode={USER_VIEW_MODE.EDIT}
              isPrimary={this.state.isPrimary}
              params={this.state.params}
              inputCount={this.state.inputCount}
              requiredNumber={this.state.requiredNumber}
              isManagerPermission={this.state.isManagerPermission}
              hasManagerPermission={this.state.hasManagerPermission}
              events={this.state.events}
              validationMessage={this.state.validationMessage}
              sideView={
                <SideMenu
                  roleId={this.roleId}
                  showLeaveThisPageDialog={this.showLeaveThisPageDialog}
                />
              }
              photoInfo={
                isPrimaryCompanyRoleId(this.roleId)
                  ? 'こちらは顔認証で使用される画像ではありません。顔認証用の画像はサブメニューの「顔写真」から登録してください。'
                  : null
              }
            />
          )}
          <Dialog
            show={this.state.dialog_show}
            done={() => {
              const userId = this.state.userId;
              masterSlideLoader.show('UserDetail', {
                state: { id: userId },
              });
            }}
            cancel={() => this.setState({ dialog_show: false })}
          />

          {/* 警告メッセージ */}
          <Confirmation
            visible={this.state.visibleConfirmation}
            title='ユーザーID（メールアドレス）の変更'
            message={INTEGRATE_USER_CHANGE_EMAIL_CONFIRM_MESSAGE}
            onConfirm={this.state.confirm}
            onCancel={() => this.handleVisibleDialog(false)}
            multilineText={true}
            confirmButtonText='更新'
            cancelButtonText='戻る'
          />
          {/* エラーダイアログ */}
          <Information
            message={this.state.errorMessage}
            buttonText={messageUtility.getMessage('I-000-017')}
            visible={this.state.errorDialogFlg}
            onClose={() => this.closeErrorDialog()}
          />
          {/* タブ切替時のダイアログ */}
          <Confirmation
            visible={this.state.leaveThisPage}
            title={messageUtility.getMessage('I-000-051')}
            confirmButtonText={messageUtility.getMessage('I-000-053')}
            cancelButtonText={messageUtility.getMessage('I-000-008')}
            message={messageUtility.getMessage('I-000-052')}
            isNegative
            onConfirm={() => {
              masterSlideLoader.show(this.state.selectedTabId, {
                state: { id: this.state.userId },
              });
            }}
            onCancel={() => this.closeDialog()}
          />
          <Modal modalRoot='root' modalState={this.state.showModal}>
            <DialogSuccessError
              msg={this.state.updateMsg}
              msgDetail={this.state.updateMsgDetail}
              updateSuccess={this.state.updateSuccess}
              multilineText={true}
              success={() => {
                if (this.state.isLogout) {
                  // ログアウト処理
                  AuthProvider.instance.logout();
                  return;
                }

                masterSlideLoader.show('UserDetail', {
                  state: { id: this.state.userId },
                });
              }}
              error={() => this.setState({ showModal: false })}
              labelBtnError={messageUtility.getMessage('I-000-017')}
            />
          </Modal>
          <ConfirmChangeIntegratedEmailDialog
            visible={this.state.visibleChangeIntegratedEmail}
            onConfirm={this.state.confirmChangeIntegratedEmail}
            onCancel={this.onHideConfirmChangeIntegratedEmail}
            data={this.state.groupIntegratedUsers}
          />
        </div>
      </div>
    );
  }
}

/**
 * @description ダイアログ
 */
const Dialog = ({ show, cancel, done }) => (
  <div
    id='modal-dialog-confirm-selected'
    className={show ? 'modal show' : 'modal'}
  >
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>編集画面を閉じる</span>
      </div>
      <div className='dialog-md__body text-left'>
        <p>
          <span className='text--muted'>
            {messageUtility.getMessage('I-000-confirmCloseEditWindow')}
          </span>
        </p>
      </div>
      <div className='dialog-md__footer-horizontal'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={cancel}
        >
          戻る
        </button>
        <button className='btn-fixedsize--negative' onClick={done}>
          {messageUtility.getMessage('I-000-closeEditWindow')}
        </button>
      </div>
    </div>
  </div>
);

const SideMenu = ({ roleId, showLeaveThisPageDialog }) => (
  <div className='contruction-detail-view__sidemenu'>
    <ul className='contruction-navi-list'>
      <li className='contruction-navi-list__item'>
        <a className='line-list line-list--contruction-navi-list select'>
          基本情報
        </a>
      </li>
      {isPrimaryCompanyRoleId(roleId) && (
        <li className='contruction-navi-list__item'>
          <a
            className='line-list line-list--contruction-navi-list'
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              showLeaveThisPageDialog('UserPhoto');
            }}
          >
            顔写真
          </a>
        </li>
      )}
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/UserEdit.jsx